import React from 'react'
import classNames from 'classnames'

interface SectionWrapperProps {
  children: React.ReactNode
  noBg?: boolean
  className?: string
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({
  children,
  noBg = false,
  className = '',
}) => (
  <div className={`mx-auto my-1 w-full max-w-[650px] px-1 ${className}`}>
    <div
      className={classNames('rounded-3xl transition-all duration-500 border', {
        'bg-surface-subtle sacred-shadow p-3.5 dark:border-white/5': !noBg,
        'bg-transparent border-transparent': noBg,
      })}
    >
      {children}
    </div>
  </div>
)

export default SectionWrapper
